import React from 'react';
import {
    TableCell,
    TableRow,
    Fade,
    IconButton,
    makeStyles,
    Theme,
    Box,
} from '@material-ui/core';
import { Save } from 'react-feather';

const useStyles = makeStyles((theme: Theme) => ({
    fontWeightMedium: {
        fontWeight: 500,
        width: 100,
    },
    labelCellCompact: {
        fontWeight: 500,
        width: 100,
        paddingRight: theme.spacing(1),
        '& .MuiIconButton-root': {
            marginRight: -theme.spacing(0.5),
        },
    },
    paper: {
        backgroundColor: theme.palette.background.paper,
    },
    paperCompact: {
        backgroundColor: theme.palette.background.paper,
        padding: theme.spacing(0.5),
    },
    typography: {
        display: 'inline-block',
    },
    input: {
        color: theme.palette.text.secondary,
        fontSize: 12,
        width: '80%',
    },
}));

export const TableRowWrapper = ({
    children,
    header,
    loading,
    handleSubmit,
    'data-testid': dataTestId,
    compact = false,
}: {
    children: React.ReactNode;
    header: string;
    loading: boolean;
    handleSubmit: Function;
    'data-testid'?: string;
    compact?: boolean;
}) => {
    const classes = useStyles();
    return (
        <TableRow data-testid={dataTestId}>
            <TableCell className={compact ? classes.labelCellCompact : classes.fontWeightMedium}>
                <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="space-between"
                >
                    {header}
                    <IconButton
                        type="submit"
                        onClick={() => handleSubmit()}
                        disabled={loading}
                    >
                        <Save size={16} />
                    </IconButton>
                </Box>
            </TableCell>
            <Fade in={!loading} timeout={600}>
                <TableCell className={compact ? classes.paperCompact : classes.paper}>{children}</TableCell>
            </Fade>
        </TableRow>
    );
};
